// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Barre d'en-tete pleine largeur, fondue avec la sidebar / mode top-nav. ───
   Meme teinte que la sidebar (#484848), hauteur = largeur sidebar repliee (64px). */
.user-info-display {
  position: fixed;
  top: 0;
  left: 64px;
  right: 0;
  height: 64px;
  background: #484848;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  /* Padding droit = inset du corps des pages (6rem) -> identite alignee avec le contenu. */
  padding: 0 6rem;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ── Nav rapide : groupe centre entre le logo et l'identite (mode top-nav). ──
   flex:1 occupe l'espace median (navbar padding-left = logo + 1cm a gauche,
   margin-right = 1cm a droite). */
/* Centree en absolu sur la navbar -> stable, independante de la largeur de l'identite
   (donc plus de decalage quand l'identite passe du skeleton au reel au reload). */
.navbar-quicknav {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 4rem;
}
/* Onglets soulignes : texte clair, soulignement orange anime sur l'actif. */
.quicknav-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.2rem;
  color: #cdd0d0;
  font-size: 1.3rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease;
}
.quicknav-item:hover {
  color: #ffffff;
}
/* Actif : texte reste blanc, c'est le soulignement qui marque la selection. */
.quicknav-item.active {
  color: #ffffff;
}
.quicknav-item--disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Indicateur glissant : un seul soulignement orange qui se deplace vers l'item actif. */
.quicknav-indicator {
  position: absolute;
  left: 0;
  bottom: -0.5rem;
  height: 2px;
  border-radius: 2px;
  background: #f97316;
  transition:
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

/* Bloc identite a droite : texte + avatar. Pleine hauteur pour ancrer le menu. */
.user-info-right {
  position: relative;
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 1.1rem;
  margin-left: auto;
  min-width: 0;
}

.user-info-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  line-height: 1.2;
  min-width: 0;
}
/* Ligne 1 : nom (en evidence) puis email (gris clair). */
.user-info-line1 {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
}
.user-info-line2 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.15rem;
}
.user-info-fullname {
  font-size: 1.35rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.01em;
  white-space: nowrap;
}
.user-info-role {
  font-size: 1.05rem;
  font-weight: 600;
  color: #f97316;
  white-space: nowrap;
}
.user-info-org,
.user-info-email {
  font-size: 1.1rem;
  color: #cdd0d0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 26rem;
}
.user-info-sep {
  color: #8c8c8c;
  font-size: 1.1rem;
}

/* Bloc identite (texte + avatar + chevron) : curseur pointeur, overlay au survol
   pour signaler qu'on peut deployer le menu. */
.user-info-identity {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  cursor: pointer;
  border-radius: 10px;
  padding: 0.2rem 0.6rem 0.2rem 0.8rem;
  /* Overlay permanent : signale en continu que la zone est interactive. */
  background: rgba(255, 255, 255, 0.07);
  transition: background 0.15s ease;
}
.user-info-right:hover .user-info-identity {
  background: rgba(255, 255, 255, 0.14);
}

/* Chevron d'affordance : indique le menu deroulant ; pivote quand il s'ouvre. */
.user-info-chevron {
  flex-shrink: 0;
  color: #cdd0d0;
  transition: transform 0.2s ease, color 0.2s ease;
}
.user-info-right:hover .user-info-chevron {
  transform: rotate(180deg);
  color: #ffffff;
}

/* Avatar a initiales (cale a droite, en miroir du logo). */
.user-info-avatar {
  position: relative;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f97316;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  -webkit-user-select: none;
          user-select: none;
}

/* Pastille de completion profil (rouge), decoupee en haut du coin de l'avatar. */
.user-info-completion-badge {
  position: absolute;
  top: -6px;
  right: -7px;
  min-width: 1.7rem;
  height: 1.7rem;
  padding: 0 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dc2626;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1;
  border-radius: 999px;
  border: 2px solid #484848;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
}

/* Etats transitoires (visiteur) : texte simple. */
.user-info-name {
  font-size: 1.2rem;
  color: #cdd0d0;
}

/* Deconnecte : Connexion / Inscription (meme style que la nav d'accueil). */
.user-info-auth {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.user-info-auth-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #f97316;
  cursor: pointer;
  transition: color 0.15s ease;
}
.user-info-auth-link:hover {
  color: #fb923c;
}
.user-info-auth-sep {
  color: #9ca3af;
  font-size: 1.1rem;
}

/* ── Menu deroulant au survol des infos user (mode top-nav). ───────────────
   Panneau sombre (texte clair), ancre sous la navbar. */
.user-info-menu {
  position: absolute;
  top: 100%;
  right: 0;
  /* Largeur calee sur l'identite survolee, mais avec un minimum pour les roles longs
     (ex. "Acheteur signataire admin") afin que le texte ne soit pas a l'etroit / colle au bord. */
  width: 100%;
  min-width: 260px;
  background: #3f3f3f;
  border: 1px solid #565656;
  border-radius: 12px;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.38);
  padding: 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-6px);
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s;
  z-index: 1100;
}
.user-info-right:hover .user-info-menu,
.user-info-menu:hover {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
/* En-tete identite du menu : avatar + nom + role + email. Cliquable -> profil. */
.user-info-menu-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.12s ease;
}
.user-info-menu-header:hover {
  background: rgba(255, 255, 255, 0.07);
}
.user-info-menu-avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f97316;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.user-info-menu-id {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.user-info-menu-name {
  font-size: 1.35rem;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-info-menu-role {
  font-size: 1.05rem;
  font-weight: 600;
  color: #f97316;
  margin-top: 0.1rem;
  /* Role potentiellement long : retour a la ligne dans la colonne (indentee sous le nom)
     plutot que de deborder ou de coller au bord du dropdown. */
  line-height: 1.25;
}
.user-info-menu-mail {
  font-size: 1.05rem;
  color: #b9bcbc;
  margin-top: 0.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info-menu-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  border: none;
  background: none;
  color: #ededed;
  font-size: 1.3rem;
  font-weight: 600;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}
.user-info-menu-item:hover {
  background: rgba(255, 255, 255, 0.09);
  color: #ffffff;
}
/* Item actif : soulignement orange (comme les onglets de la navbar), plus de ligne pleine. */
.user-info-menu-item.active {
  background: none;
  color: #ffffff;
}
.user-info-menu-item.active::after {
  content: '';
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 0.4rem;
  height: 2px;
  border-radius: 2px;
  background: #f97316;
}
/* Separateur gris clair entre les items et la deconnexion. */
.user-info-menu-sep {
  height: 1px;
  background: rgba(255, 255, 255, 0.16);
  margin: 0.35rem 0.4rem;
}
.user-info-menu-logout {
  color: #f3a0a0;
}
.user-info-menu-logout:hover {
  background: rgba(248, 113, 113, 0.14);
  color: #fca5a5;
}

/* ── Pastilles : comptages + completion (rouge + texte blanc). ───────────── */
.nav-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.7rem;
  height: 1.7rem;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: #dc2626;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
}
.nav-badge--completion {
  background: #dc2626;
  color: #ffffff;
}
/* Items visibles : pastille en coin (absolue) -> n'elargit pas l'item, donc son
   apparition (chargement du compteur) ne decale pas la nav ni le soulignement. */
.quicknav-item .nav-badge {
  position: absolute;
  top: -0.5rem;
  right: -0.9rem;
  min-width: 1.5rem;
  height: 1.5rem;
  font-size: 0.85rem;
}

/* ── Skeleton de la navbar (chargement). Placeholders + balayage shimmer. ── */
.nav-skel {
  display: inline-block;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.09);
  background-image: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.13),
    transparent
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: -150% 0;
  animation: nav-skel-shimmer 1.4s ease-in-out infinite;
}
@keyframes nav-skel-shimmer {
  to {
    background-position: 150% 0;
  }
}
.nav-skel-item {
  width: 8rem;
  height: 1.8rem;
  border-radius: 8px;
}
.nav-skel-line {
  display: block;
  height: 1.1rem;
  border-radius: 5px;
}
.nav-skel-line--name {
  width: 13rem;
}
.nav-skel-line--sub {
  width: 8rem;
  margin-top: 0.6rem;
}
.nav-skel-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

/* Bouton demo (conserve, masque par defaut). */
.user-info-demo-btn {
  margin-left: 1rem;
  background: #f97316;
  color: #fff;
  border: none;
  padding: 0.2rem 0.65rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}
.user-info-demo-btn:hover:not(:disabled) {
  background: #ea6c0a;
}
.user-info-demo-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/composants/UserInfo/UserInfo.css"],"names":[],"mappings":"AAAA;oFACoF;AACpF;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,yFAAyF;EACzF,eAAe;EACf,kDAAkD;AACpD;;AAEA;;kCAEkC;AAClC;kFACkF;AAClF;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA,8EAA8E;AAC9E;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wFAAwF;AACxF;EACE,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB;;4CAE0C;EAC1C,oBAAoB;AACtB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;AACA,yDAAyD;AACzD;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;+CAC+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,wEAAwE;EACxE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;wDACwD;AACxD;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR;kGACgG;EAChG,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,sEAAsE;EACtE,aAAa;AACf;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;AACA,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB;+DAC6D;EAC7D,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA,6FAA6F;AAC7F;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA,6DAA6D;AAC7D;EACE,WAAW;EACX,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;iFACiF;AACjF;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C;;;;;GAKC;EACD,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,qDAAqD;AACvD;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* ── Barre d'en-tete pleine largeur, fondue avec la sidebar / mode top-nav. ───\n   Meme teinte que la sidebar (#484848), hauteur = largeur sidebar repliee (64px). */\n.user-info-display {\n  position: fixed;\n  top: 0;\n  left: 64px;\n  right: 0;\n  height: 64px;\n  background: #484848;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1.5rem;\n  /* Padding droit = inset du corps des pages (6rem) -> identite alignee avec le contenu. */\n  padding: 0 6rem;\n  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ── Nav rapide : groupe centre entre le logo et l'identite (mode top-nav). ──\n   flex:1 occupe l'espace median (navbar padding-left = logo + 1cm a gauche,\n   margin-right = 1cm a droite). */\n/* Centree en absolu sur la navbar -> stable, independante de la largeur de l'identite\n   (donc plus de decalage quand l'identite passe du skeleton au reel au reload). */\n.navbar-quicknav {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  gap: 4rem;\n}\n/* Onglets soulignes : texte clair, soulignement orange anime sur l'actif. */\n.quicknav-item {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.2rem;\n  color: #cdd0d0;\n  font-size: 1.3rem;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n.quicknav-item:hover {\n  color: #ffffff;\n}\n/* Actif : texte reste blanc, c'est le soulignement qui marque la selection. */\n.quicknav-item.active {\n  color: #ffffff;\n}\n.quicknav-item--disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Indicateur glissant : un seul soulignement orange qui se deplace vers l'item actif. */\n.quicknav-indicator {\n  position: absolute;\n  left: 0;\n  bottom: -0.5rem;\n  height: 2px;\n  border-radius: 2px;\n  background: #f97316;\n  transition:\n    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n    width 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n}\n\n/* Bloc identite a droite : texte + avatar. Pleine hauteur pour ancrer le menu. */\n.user-info-right {\n  position: relative;\n  align-self: stretch;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 1.1rem;\n  margin-left: auto;\n  min-width: 0;\n}\n\n.user-info-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  line-height: 1.2;\n  min-width: 0;\n}\n/* Ligne 1 : nom (en evidence) puis email (gris clair). */\n.user-info-line1 {\n  display: flex;\n  align-items: baseline;\n  gap: 0.6rem;\n}\n.user-info-line2 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.15rem;\n}\n.user-info-fullname {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n.user-info-role {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #f97316;\n  white-space: nowrap;\n}\n.user-info-org,\n.user-info-email {\n  font-size: 1.1rem;\n  color: #cdd0d0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 26rem;\n}\n.user-info-sep {\n  color: #8c8c8c;\n  font-size: 1.1rem;\n}\n\n/* Bloc identite (texte + avatar + chevron) : curseur pointeur, overlay au survol\n   pour signaler qu'on peut deployer le menu. */\n.user-info-identity {\n  display: flex;\n  align-items: center;\n  gap: 1.1rem;\n  cursor: pointer;\n  border-radius: 10px;\n  padding: 0.2rem 0.6rem 0.2rem 0.8rem;\n  /* Overlay permanent : signale en continu que la zone est interactive. */\n  background: rgba(255, 255, 255, 0.07);\n  transition: background 0.15s ease;\n}\n.user-info-right:hover .user-info-identity {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n/* Chevron d'affordance : indique le menu deroulant ; pivote quand il s'ouvre. */\n.user-info-chevron {\n  flex-shrink: 0;\n  color: #cdd0d0;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n.user-info-right:hover .user-info-chevron {\n  transform: rotate(180deg);\n  color: #ffffff;\n}\n\n/* Avatar a initiales (cale a droite, en miroir du logo). */\n.user-info-avatar {\n  position: relative;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #f97316;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  user-select: none;\n}\n\n/* Pastille de completion profil (rouge), decoupee en haut du coin de l'avatar. */\n.user-info-completion-badge {\n  position: absolute;\n  top: -6px;\n  right: -7px;\n  min-width: 1.7rem;\n  height: 1.7rem;\n  padding: 0 0.35rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #dc2626;\n  color: #ffffff;\n  font-size: 0.9rem;\n  font-weight: 800;\n  line-height: 1;\n  border-radius: 999px;\n  border: 2px solid #484848;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  white-space: nowrap;\n}\n\n/* Etats transitoires (visiteur) : texte simple. */\n.user-info-name {\n  font-size: 1.2rem;\n  color: #cdd0d0;\n}\n\n/* Deconnecte : Connexion / Inscription (meme style que la nav d'accueil). */\n.user-info-auth {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n.user-info-auth-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #f97316;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n.user-info-auth-link:hover {\n  color: #fb923c;\n}\n.user-info-auth-sep {\n  color: #9ca3af;\n  font-size: 1.1rem;\n}\n\n/* ── Menu deroulant au survol des infos user (mode top-nav). ───────────────\n   Panneau sombre (texte clair), ancre sous la navbar. */\n.user-info-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  /* Largeur calee sur l'identite survolee, mais avec un minimum pour les roles longs\n     (ex. \"Acheteur signataire admin\") afin que le texte ne soit pas a l'etroit / colle au bord. */\n  width: 100%;\n  min-width: 260px;\n  background: #3f3f3f;\n  border: 1px solid #565656;\n  border-radius: 12px;\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.38);\n  padding: 0.6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-6px);\n  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s;\n  z-index: 1100;\n}\n.user-info-right:hover .user-info-menu,\n.user-info-menu:hover {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n/* En-tete identite du menu : avatar + nom + role + email. Cliquable -> profil. */\n.user-info-menu-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.7rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n.user-info-menu-header:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n.user-info-menu-avatar {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #f97316;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n.user-info-menu-id {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.user-info-menu-name {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.user-info-menu-role {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #f97316;\n  margin-top: 0.1rem;\n  /* Role potentiellement long : retour a la ligne dans la colonne (indentee sous le nom)\n     plutot que de deborder ou de coller au bord du dropdown. */\n  line-height: 1.25;\n}\n.user-info-menu-mail {\n  font-size: 1.05rem;\n  color: #b9bcbc;\n  margin-top: 0.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-info-menu-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  width: 100%;\n  padding: 0.85rem 1rem;\n  border-radius: 8px;\n  border: none;\n  background: none;\n  color: #ededed;\n  font-size: 1.3rem;\n  font-weight: 600;\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n.user-info-menu-item:hover {\n  background: rgba(255, 255, 255, 0.09);\n  color: #ffffff;\n}\n/* Item actif : soulignement orange (comme les onglets de la navbar), plus de ligne pleine. */\n.user-info-menu-item.active {\n  background: none;\n  color: #ffffff;\n}\n.user-info-menu-item.active::after {\n  content: '';\n  position: absolute;\n  left: 1rem;\n  right: 1rem;\n  bottom: 0.4rem;\n  height: 2px;\n  border-radius: 2px;\n  background: #f97316;\n}\n/* Separateur gris clair entre les items et la deconnexion. */\n.user-info-menu-sep {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.16);\n  margin: 0.35rem 0.4rem;\n}\n.user-info-menu-logout {\n  color: #f3a0a0;\n}\n.user-info-menu-logout:hover {\n  background: rgba(248, 113, 113, 0.14);\n  color: #fca5a5;\n}\n\n/* ── Pastilles : comptages + completion (rouge + texte blanc). ───────────── */\n.nav-badge {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.7rem;\n  height: 1.7rem;\n  padding: 0 0.4rem;\n  border-radius: 999px;\n  background: #dc2626;\n  color: #ffffff;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1;\n}\n.nav-badge--completion {\n  background: #dc2626;\n  color: #ffffff;\n}\n/* Items visibles : pastille en coin (absolue) -> n'elargit pas l'item, donc son\n   apparition (chargement du compteur) ne decale pas la nav ni le soulignement. */\n.quicknav-item .nav-badge {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.9rem;\n  min-width: 1.5rem;\n  height: 1.5rem;\n  font-size: 0.85rem;\n}\n\n/* ── Skeleton de la navbar (chargement). Placeholders + balayage shimmer. ── */\n.nav-skel {\n  display: inline-block;\n  border-radius: 6px;\n  background-color: rgba(255, 255, 255, 0.09);\n  background-image: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.13),\n    transparent\n  );\n  background-size: 200% 100%;\n  background-repeat: no-repeat;\n  background-position: -150% 0;\n  animation: nav-skel-shimmer 1.4s ease-in-out infinite;\n}\n@keyframes nav-skel-shimmer {\n  to {\n    background-position: 150% 0;\n  }\n}\n.nav-skel-item {\n  width: 8rem;\n  height: 1.8rem;\n  border-radius: 8px;\n}\n.nav-skel-line {\n  display: block;\n  height: 1.1rem;\n  border-radius: 5px;\n}\n.nav-skel-line--name {\n  width: 13rem;\n}\n.nav-skel-line--sub {\n  width: 8rem;\n  margin-top: 0.6rem;\n}\n.nav-skel-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n}\n\n/* Bouton demo (conserve, masque par defaut). */\n.user-info-demo-btn {\n  margin-left: 1rem;\n  background: #f97316;\n  color: #fff;\n  border: none;\n  padding: 0.2rem 0.65rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n.user-info-demo-btn:hover:not(:disabled) {\n  background: #ea6c0a;\n}\n.user-info-demo-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
